// @flow
/* -----------------Globals--------------- */
import React from 'react';

/* -----------------3rd-Party--------------- */
import clsx from 'clsx';

/* -----------------UI--------------- */
import { withStyles } from '@material-ui/core/styles';
import MaterialBreadcrumbs from '@material-ui/core/Breadcrumbs';
import {
  Typography,
  Box,
} from '@material-ui/core';

/* -----------------Analytics--------------- */
import {
  trackCustomEvent,
} from '../../analytics/tracking';
import {
  events,
} from 'common/analytics/constants';

/* -----------------Icons--------------- */
import {
  ChevronRight,
} from 'mdi-material-ui';

/* -----------------Child components--------------- */
import Link from './link';

/* -----------------Styles--------------- */
const styles = theme => ({
  breadcrumbsContainer: {
    alignSelf: 'center',
  },
  breadcrumbsIcon: {
    height: 20,
    width: 20,
    alignSelf: 'center',
    marginRight: -8,
    marginLeft: -8,
  },
  breadcrumbLink: {
    textDecoration: 'none',
    fontSize: 14,
    fontWeight: theme.fontWeights.semiBold,
    color: theme.palette.secondary.main,
    '&:hover': {
      color: theme.palette.secondary.dark,
    },
  },
  breadcrumbWithoutlink: {
    fontSize: 14,
    fontWeight: theme.fontWeights.semiBold,
  },
});

/* -----------------Types--------------- */
type Classes = {
  breadcrumbsContainer: string,
  breadcrumbsIcon: string,
  breadcrumbLink: string,
  breadcrumbWithoutlink: string
};

type BreadcrumbValue = {
  title: string,
  link: string,
}

/* -----------------Props--------------- */
type Props = {
  classes: Classes,
  customClasses: *,
  breadcrumbValues: BreadcrumbValue[],
};

/* -----------------Component--------------- */
const Breadcrumbs = (props: Props) => {
  const {
    classes,
    breadcrumbValues,
    customClasses,
  } = props;

  const sendEvent = () => {
    trackCustomEvent({
      eventName: events.breadcrumb,
    });
  };
  const showChevronForSingleItem = breadcrumbValues.length === 1;
  return (
    <MaterialBreadcrumbs
      className={classes.breadcrumbsContainer}
      onClick={sendEvent}
      maxItems={3}
      aria-label="breadcrumb"
      separator={(
       !showChevronForSingleItem ? (
         <ChevronRight
           className={classes.breadcrumbsIcon}
         />
       ) : null
          )}
    >
      {
          breadcrumbValues.map((item) => (
            item.link ? (
              <Link
                className={clsx(customClasses, classes.breadcrumbLink)}
                href={item.link}
                key={item.link}
                prefetch={false}
              >
                {item.title}
              </Link>
            ) : (
              <Typography className={classes.breadcrumbWithoutlink}>
                {item.title}
              </Typography>
            )
          ))
      }
      {showChevronForSingleItem ? (
        <Box
          display="flex"
          alignItems="center"
        >
          <ChevronRight
            className={classes.breadcrumbsIcon}
          />
        </Box>
      ) : null}
    </MaterialBreadcrumbs>
  );
};

export default withStyles(styles)(Breadcrumbs);
